// src/lib/resume/resumeReducer.ts

import { ResumeContent } from "../lib/resumeTypes";
import { updateByPath, getByPath } from "../lib/resumeHelpers";

export type ResumeAction =
  | { type: "UPDATE_FIELD"; path: string; value: any }
  | { type: "ADD_ITEM"; path: string; value: any }
  | { type: "REMOVE_ITEM"; path: string; index: number }
  | { type: "SET_FULL_RESUME"; value: ResumeContent };

export function resumeReducer(
  state: ResumeContent,
  action: ResumeAction
): ResumeContent {
  switch (action.type) {
    case "SET_FULL_RESUME":
      return { ...state, ...action.value };

    case "UPDATE_FIELD":
      return updateByPath(state, action.path, action.value);

    case "ADD_ITEM": {
      const list = getByPath(state, action.path) || [];
      return updateByPath(state, action.path, [...list, action.value]);
    }

    case "REMOVE_ITEM": {
      const list = getByPath(state, action.path) || [];
      return updateByPath(
        state,
        action.path,
        list.filter((_: any, i: number) => i !== action.index)
      );
    }

    default:
      return state;
  }
}
